import React, { createContext, useContext, useState, useCallback } from 'react';
import { translations } from '../i18n/translations';

const LanguageContext = createContext(null);

export const useLanguage = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error('useLanguage must be used within LanguageProvider');
  return ctx;
};

const SUPPORTED = ['en', 'es', 'fr'];

export const LanguageProvider = ({ children }) => {
  const [lang, setLangState] = useState(() => {
    const stored = localStorage.getItem('lang');
    return SUPPORTED.includes(stored) ? stored : 'en';
  });

  const setLang = useCallback((newLang) => {
    if (!SUPPORTED.includes(newLang)) return;
    localStorage.setItem('lang', newLang);
    setLangState(newLang);
  }, []);

  // t('nav.myStory') -> resolves nested keys, falls back to English then the key itself
  const t = useCallback(
    (key) => {
      const resolve = (dict) => key.split('.').reduce((acc, part) => (acc ? acc[part] : undefined), dict);
      return resolve(translations[lang]) ?? resolve(translations.en) ?? key;
    },
    [lang]
  );

  return (
    <LanguageContext.Provider value={{ lang, setLang, t, supported: SUPPORTED }}>
      {children}
    </LanguageContext.Provider>
  );
};
